import React from 'react';
import styled from 'styled-components';
import Fragment from 'react-dot-fragment';
import Icon from '../../containers/assets/error-icon.png';

const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  z-index: 1001;
`;

const AlertWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 400px;
  position: fixed;
  z-index: 1002;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 32px 32px 24px;
`;

const AlertBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const FullWidth = styled.div`
  flex: 1;
`;

const AlertTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const AlertMessage = styled.div`
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 8px;
`;

const AlertButton = styled.div`
  background: #5c91f5;
  border-radius: 4px;
  color: #ffffff;
  border: 1.5px solid #5c91f5;
  display: inline-block;
  float: right;
  margin-top: 24px;
  padding: 6px 14px;
  cursor: pointer;

  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;

const ErrorAlert = ({ title, message, onHide }) => (
  <Fragment>
    <AlertOverlay />
    <AlertWrapper>
      <AlertBody>
        <div><img src={Icon} alt="" /></div>
        <FullWidth>
          <AlertTitle>{title}</AlertTitle>
          <AlertMessage>{message}</AlertMessage>
          <AlertButton onClick={onHide}>Got it</AlertButton>
        </FullWidth>
      </AlertBody>
    </AlertWrapper>
  </Fragment>
);

export default ErrorAlert;



// WEBPACK FOOTER //
// ./src/components/alerts/error.js